import { createTheme } from '@mui/material';

const theme = createTheme();

const container = {
  MuiContainer: {
    styleOverrides: {
      root: {
        [theme.breakpoints.down('md')]: {
          padding: 0,
        },
      },
    },
  },
};

export default container;
